import CheckIcon from '@mui/icons-material/Check';
export const radioIcon = (
  <span
    style={{
      borderRadius: '50%',
      width: 24,
      height: 24,
      border: '2px solid #fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'transparent'
    }}
  />
);

export const radioCheckedIcon = (
  <span
    style={{
      borderRadius: '50%',
      width: 24,
      height: 24,
      background: '#4ede4c',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}
  >
    <CheckIcon style={{ color: '#fff', fontSize: 18 }} />
  </span>
);
